export default __webpack_public_path__ + "static/media/SourceSerifPro-SemiBoldItalic.1266f2c1.ttf";